export function getRegionName(number) {
    const envName = `VUE_APP_REGION_${number}_NAME`;
    if (process.env[envName]) {
        return process.env[envName];
    } else {
        return `Region ${number}`;
    }
}